module.exports = __webpack_public_path__ + "static/2csm_ACO-Stormbrixx-Systemuebersicht-Headerbild-93c88de7efe62b4afb2dff39b85a769d.jpg";